var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"inline-flex items-center gap-2 py-0.5 px-4 rounded border text-base",class:{
    'bg-primary-50 text-primary cursor-pointer hover:bg-primary-100':
      !_vm.disabled,
    'bg-gray-300 text-gray-500 pointer-events-none':
      _vm.disabled,
  },attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e(),_c('font-awesome-icon',{staticClass:"text-main text-sm",class:{
      'text-primary': !_vm.disabled,
      'text-gray-500': _vm.disabled,
    },attrs:{"icon":"chevron-down"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }